var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgList = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00023 2.66661C6.00023 2.39047 6.22408 2.16661 6.50023 2.16661H15.1669C15.443 2.16661 15.6669 2.39047 15.6669 2.66661C15.6669 2.94275 15.443 3.16661 15.1669 3.16661H6.50023C6.22408 3.16661 6.00023 2.94275 6.00023 2.66661ZM6.00023 7.99994C6.00023 7.7238 6.22408 7.49994 6.50023 7.49994L15.1669 7.49995C15.443 7.49995 15.6669 7.7238 15.6669 7.99995C15.6669 8.27609 15.443 8.49995 15.1669 8.49995L6.50023 8.49994C6.22408 8.49994 6.00023 8.27609 6.00023 7.99994ZM6.00023 13.3333C6.00023 13.0571 6.22408 12.8333 6.50023 12.8333L15.1669 12.8333C15.443 12.8333 15.6669 13.0571 15.6669 13.3333C15.6669 13.6094 15.443 13.8333 15.1669 13.8333L6.50023 13.8333C6.22408 13.8333 6.00023 13.6094 6.00023 13.3333Z",
    fill: "#23252F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16732 2.66667C3.16732 3.03486 2.86884 3.33333 2.50065 3.33333C2.13246 3.33333 1.83398 3.03486 1.83398 2.66667C1.83398 2.29848 2.13246 2 2.50065 2C2.86884 2 3.16732 2.29848 3.16732 2.66667Z",
    fill: "#23252F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16732 8C3.16732 8.36819 2.86884 8.66667 2.50065 8.66667C2.13246 8.66667 1.83398 8.36819 1.83398 8C1.83398 7.63181 2.13246 7.33333 2.50065 7.33333C2.86884 7.33333 3.16732 7.63181 3.16732 8Z",
    fill: "#23252F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16732 13.3333C3.16732 13.7015 2.86884 14 2.50065 14C2.13246 14 1.83398 13.7015 1.83398 13.3333C1.83398 12.9651 2.13246 12.6667 2.50065 12.6667C2.86884 12.6667 3.16732 12.9651 3.16732 13.3333Z",
    fill: "#23252F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgList);
export default ForwardRef;